import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnChanges,
  Output,
  SimpleChange
} from '@angular/core'

@Component({
  selector: 'app-multi-select-input',
  templateUrl: './multi-select-input.component.html',
  styleUrls: ['./multi-select-input.component.scss']
})
export class MultiSelectInputComponent implements OnChanges {
  @Input() label: string
  @Input() options: string[]
  @Input() activeOptions: string[]

  @Output() valueChanged: EventEmitter<string[]> = new EventEmitter()

  showList = false

  constructor(private elementRef: ElementRef, private ngZone: NgZone) {}

  ngOnChanges(changes: { selectOptions?: SimpleChange }) {
    // Reset form value if we change select options.
    if (this.activeOptions?.length && changes.selectOptions) {
      return this.selectNone()
    }

    if (!this.activeOptions) {
      this.activeOptions = []
    } else {
      if (Array.isArray(this.activeOptions)) {
        this.activeOptions = this.activeOptions.map((option) => String(option))
      } else {
        this.activeOptions = [String(this.activeOptions)]
      }
    }
  }

  toggleSelected(option: string): void {
    const clickedOption: string = String(option)

    this.ngZone.run(() => {
      const index = this.activeOptions.indexOf(clickedOption)
      if (index !== -1) {
        this.activeOptions.splice(index, 1)
      } else {
        this.activeOptions.push(String(option))
      }

      this.valueChanged.emit(this.activeOptions)
    })
  }

  selectAll() {
    this.ngZone.run(() => {
      this.activeOptions = this.options
      this.valueChanged.emit(this.activeOptions)
    })
  }

  selectNone() {
    this.ngZone.run(() => {
      this.activeOptions = []
      this.valueChanged.emit(this.activeOptions)
    })
  }

  // Click outside closes list
  @HostListener('document:click', ['$event.target'])
  clickOut(eventTarget: any) {
    if (
      this.showList &&
      !this.elementRef.nativeElement.contains(eventTarget) &&
      !eventTarget.className.includes('mass-selection-button')
    ) {
      this.showList = false
    }
  }
}
